import { StationPageWrapper } from '@app/core/routing/StationPageWrapper';
import { ComposeCreatePage } from './ComposeCreatePage';

/**
 * Station-scoped shell for the create composition screen (resolves `:slug` from the URL).
 */
export function ComposeCreateStationPage() {
  return (
    <StationPageWrapper>
      <ComposeCreatePage />
    </StationPageWrapper>
  );
}
